import CryptoJS from 'crypto-js/crypto-js';
import Key01 from './key1_game';
import KEY02 from './key2_game';
import KEY03 from './key3_game';
import KEY04 from './key4_game';

// 注释会在生产删除 密码为: thwl
var value = Key01['t'] + KEY02['h'] + KEY03['w'] + KEY04['l'];
// 默认的 KEY 与 iv 如果没有给
var KEY = CryptoJS.enc.Utf8.parse(value); // ""中与后台一样  密码
var IV = CryptoJS.enc.Utf8.parse(); // ""中与后台一样

/**
 * AES加密 ：字符串 key iv  返回base64
 */
export function Encrypt(word, keyStr, ivStr) {
  var key = KEY;
  var iv = IV;
  if (keyStr) {
    key = CryptoJS.enc.Utf8.parse(keyStr);
    iv = CryptoJS.enc.Utf8.parse(ivStr);
  }
  var srcs = CryptoJS.enc.Utf8.parse(word);
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  // console.log("-=-=-=-", encrypted.ciphertext)
  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}
export function shuffle(arr) {
  for (var i = arr.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1)) // 随机生成 [0, i] 范围内的整数
    ;
    // 交换当前位置和随机位置的元素
    var _ref = [arr[j], arr[i]];
    arr[i] = _ref[0];
    arr[j] = _ref[1];
  }
  return arr;
}